import React, { useRef, useEffect } from "react";
import Header from "../components/header.tsx";
import { Box, Typography, Card, Divider, Button, CardContent, CardMedia, IconButton } from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import LocationSearchingIcon from '@mui/icons-material/LocationSearching';
import Footer from "../components/footer.tsx";
import DoneIcon from '@mui/icons-material/Done';
import deals_1 from '../assets/deals_1.jpg';
import deals_2 from '../assets/deals_2.jpg';
import deals_3 from '../assets/deals_3.jpg';
import deals_4 from '../assets/deals_4.jpg';
import deals_5 from '../assets/deals_5.jpg';
import beauty_products from '../assets/beauty_products.jpeg';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useNavigate } from "react-router-dom";

const OrderPlaced = () => {

    const navigate = useNavigate();
    const scrollRef = useRef<HTMLDivElement>(null);
    const scrollRef1 = useRef<HTMLDivElement>(null);
    const leftContentRef = useRef<HTMLDivElement>(null);
    const rightAdsRef = useRef<HTMLDivElement>(null);

    const scroll = (scrollOffset: any) => {
        if (scrollRef.current) {
            scrollRef.current.scrollBy({ left: scrollOffset, behavior: 'smooth' });
        }
    };

    const scroll1 = (scrollOffset: any) => {
        if (scrollRef1.current) {
            scrollRef1.current.scrollBy({ left: scrollOffset, behavior: 'smooth' });
        }
    };

    const dealsProduct = [
        {
            id: 1,
            discount: '-38%',
            price: 'AED499.99',
            oldPrice: 'AED799.99',
            title: 'Ultra HD Smart TV',
            size: '55"',
            endsIn: '12:45:00',
            image: deals_1,
        },
        {
            id: 2,
            discount: '-20%',
            price: 'AED299.99',
            oldPrice: 'AED379.99',
            title: 'Bluetooth Speaker',
            size: 'Compact',
            endsIn: '06:30:15',
            image: deals_2,
        },
        {
            id: 3,
            discount: '-45%',
            price: 'AED149.99',
            oldPrice: 'AED269.99',
            title: 'Wireless Headphones',
            size: 'Over-ear',
            endsIn: '03:12:50',
            image: deals_3,
        },
        {
            id: 4,
            discount: '-25%',
            price: 'AED59.99',
            oldPrice: 'AED79.99',
            title: 'Smartwatch Pro',
            size: '42mm',
            endsIn: '10:00:00',
            image: deals_4,
        },
        {
            id: 5,
            discount: '-50%',
            price: 'AED999.99',
            oldPrice: 'AED1999.99',
            title: 'Gaming Laptop',
            size: '15.6"',
            endsIn: '18:00:00',
            image: deals_5,
        },
    ];

    useEffect(() => {
        const syncHeights = () => {
            if (leftContentRef.current && rightAdsRef.current) {
                const leftHeight = leftContentRef.current.offsetHeight;
                rightAdsRef.current.style.height = `${leftHeight}px`;
            }
        };

        // Sync once on mount
        syncHeights();

        // Sync on window resize
        window.addEventListener("resize", syncHeights);
        return () => window.removeEventListener("resize", syncHeights);
    }, []);

    return (
        <>
            {/* header */}
            <Header />
            {/* end header */}

            {/* order placed body */}
            {/*  <Box
                minHeight="100vh"
                display="flex"
                alignItems="center"
                justifyContent="center"
                bgcolor="#f9f9f9"
                flexDirection={"column"}
                p={2}
                gap={1}
            >
                <CheckCircleIcon sx={{ color: 'green', fontSize: '96px' }} />
                <Typography sx={{ color: '#000', fontSize: '25px', fontWeight: 'bold' }}>Order Placed!</Typography>
                <Typography sx={{ color: 'gray', fontSize: '18px' }}>Your order has been successfully placed and will be processed soon.</Typography>
                <Card sx={{ p: 2, borderRadius: 2, boxShadow: 2 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                        <Typography sx={{ color: 'gray' }}>Order ID: </Typography>
                        <Typography sx={{ display: 'flex', flexDirection: 'column' }}>
                            ORD-184567
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                        <Typography sx={{ color: 'gray' }}>Order Date: </Typography>
                        <Typography>
                            7/13/2025
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                        <Typography sx={{ color: 'gray' }}>Items: </Typography>
                        <Typography>
                            4 Items
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                        <Typography sx={{ color: 'gray' }}>Shipping to: </Typography>
                        <Typography>
                            Jhon Doe
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                        <Typography sx={{ color: 'gray' }}>Payment Method: </Typography>
                        <Typography>
                            UPI
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                        <Typography sx={{ color: 'gray' }}>Total Amount: </Typography>
                        <Typography>
                            AED129.97
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                        <Typography sx={{ color: 'gray' }}>You Saved: </Typography>
                        <Typography color="green">
                            AED155.00
                        </Typography>
                    </Box>
                    <Box>
                        <Typography fontSize={14} color={"green"} sx={{ background: '#D1FFBD', padding: 1, borderRadius: '5px', display: 'flex', alignItems: 'center', gap: 1 }}><LocalShippingIcon />Estimated delivery: Tuesday, July 16 - Wednesday, July 17</Typography>
                    </Box>
                </Card>
                <Button sx={{ background: '#C32032', color: '#fff', textTransform: 'none', width: '30%' }}>Continue Shopping</Button>
                <Button sx={{ border: '1px solid #C32032', color: '#C32032', textTransform: 'none', width: '30%', display: 'flex', gap: '5px' }}><LocationSearchingIcon sx={{ fontSize: '18px' }} />Track Order</Button>
            </Box> */}

            {/* body section */}
            <Box sx={{ padding: '3%' }}>
                {/* order placed section */}
                <Box
                    // minHeight="100vh"
                    display="flex"
                    flexDirection={{ xs: 'column', md: 'row' }}
                    alignItems={{ xs: "stretch", md: "flex-start" }}
                    justifyContent="center"
                    bgcolor="#f9f9f9"
                    p={2}
                    gap={1}
                >

                    <Box
                        display="flex"
                        flexDirection={{ xs: "column", md: "row" }}
                        border="2px solid"
                        borderColor="success.main"
                        borderRadius={2}
                        p={3}
                        // maxWidth="900px"
                        bgcolor="white"
                        width={{ md: "100%" }}
                    >
                        {/* Left side */}
                        <Box flex={2} pr={{ md: 3 }} mb={{ xs: 2, md: 0 }}>
                            <Typography variant="h5" color="success.main" fontWeight="bold" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                <DoneIcon sx={{ fontSize: '40px' }} /> Thank You! Your Order Has Been Placed.
                            </Typography>
                            <Typography variant="body1" color="#000">
                                A email confirmation has been sent to you.
                            </Typography>
                            <Typography variant="body1" color="#000">
                                Get shipments notifications on your mobile device with the free FF-App.
                            </Typography>
                            <Card sx={{ p: 2, borderRadius: 2, boxShadow: 2, mt: 2 }}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                                    <Typography sx={{ color: 'gray' }}>Order ID: </Typography>
                                    <Typography sx={{ display: 'flex', flexDirection: 'column' }}>
                                        ORD-184567
                                    </Typography>
                                </Box>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                    <Typography sx={{ color: 'gray' }}>Order Date: </Typography>
                                    <Typography>
                                        7/13/2025
                                    </Typography>
                                </Box>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                    <Typography sx={{ color: 'gray' }}>Items: </Typography>
                                    <Typography>
                                        4 Items
                                    </Typography>
                                </Box>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                    <Typography sx={{ color: 'gray' }}>Shipping to: </Typography>
                                    <Typography>
                                        Jhon Doe
                                    </Typography>
                                </Box>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                    <Typography sx={{ color: 'gray' }}>Payment Method: </Typography>
                                    <Typography>
                                        UPI
                                    </Typography>
                                </Box>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                    <Typography sx={{ color: 'gray' }}>Total Amount: </Typography>
                                    <Typography>
                                        AED129.97
                                    </Typography>
                                </Box>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                    <Typography sx={{ color: 'gray' }}>You Saved: </Typography>
                                    <Typography color="green">
                                        AED155.00
                                    </Typography>
                                </Box>
                                <Box>
                                    <Typography fontSize={14} color={"green"} sx={{ background: '#D1FFBD', padding: 1, borderRadius: '5px', display: 'flex', alignItems: 'center', gap: 1 }}><LocalShippingIcon />Estimated delivery: Tuesday, July 16 - Wednesday, July 17</Typography>
                                </Box>
                            </Card>
                        </Box>

                        {/* Right side */}
                        <Box flex={1} display="flex" flexDirection="column" gap={2} justifyContent="center" alignItems={{ xs: "flex-start", md: "flex-end" }}>
                            <Button sx={{ background: '#C32032', color: '#fff', textTransform: 'none' }} fullWidth onClick={() => navigate('/')}>Continue Shopping</Button>
                            <Button sx={{ border: '1px solid #C32032', color: '#C32032', textTransform: 'none', display: 'flex', gap: '5px' }} fullWidth><LocationSearchingIcon sx={{ fontSize: '18px' }} />Track Order</Button>

                        </Box>
                    </Box>
                </Box>
                {/* end order placed body */}

                {/* recommendations related items */}
                <Box
                    minHeight="100vh"
                    display="flex"
                    flexDirection={{ xs: 'column', md: 'row' }}
                    alignItems={{ xs: "stretch", md: "flex-start" }}
                    justifyContent="center"
                    bgcolor="#f9f9f9"
                    p={2}
                    gap={1}
                >
                    {/* scrollable products rows */}
                    <Box ref={leftContentRef} sx={{ p: 2, width: { xs: '100%', md: '70%' }, position: 'relative' }}>
                        {/* related items you've searched */}
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Typography
                                sx={{
                                    color: '#000',
                                    fontSize: '20px',
                                    fontWeight: 'bold',
                                    mb: 2,
                                    display: 'flex',
                                    gap: '5px',
                                    alignItems: 'center',
                                }}
                            >
                                Related to items you've viewed
                            </Typography>
                            {/*  <Typography
                            className="see-all-link"
                            sx={{
                                fontSize: '14px',
                                '&:hover': { textDecoration: 'underline' },
                            }}
                        >
                            See All
                        </Typography> */}
                        </Box>

                        {/* Carousel Wrapper */}
                        <Box sx={{ position: 'relative' }}>
                            {/* Left Arrow */}
                            <IconButton
                                sx={{
                                    position: 'absolute',
                                    top: '40%',
                                    left: -10,
                                    zIndex: 1,
                                    backgroundColor: 'white',
                                    boxShadow: 2,
                                    '&:hover': { backgroundColor: '#f0f0f0' },
                                    display: 'flex',
                                    width: 40,
                                    height: 40,
                                    borderRadius: '50%',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                                onClick={() => scroll(-300)}
                            >
                                <ArrowBackIosIcon sx={{ ml: '8px' }} />
                            </IconButton>

                            {/* Products */}
                            <Box
                                ref={scrollRef}
                                sx={{
                                    display: 'flex',
                                    overflowX: 'auto',
                                    gap: 2,
                                    scrollBehavior: 'smooth',
                                    pb: 1,
                                    '&::-webkit-scrollbar': { display: 'none' },
                                }}
                            >
                                {dealsProduct.map((product, index) => (
                                    <Card
                                        key={index}
                                        sx={{
                                            minWidth: 220,
                                            flex: '0 0 auto',
                                            borderRadius: 2,
                                            boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                                            transition: 'transform 0.2s ease-in-out',
                                            '&:hover': {
                                                transform: 'translateY(-5px)',
                                                boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                                            },
                                            border: '1px solid #CBCBCB',
                                        }}
                                    >
                                        <CardMedia component="img" image={product.image} alt={`product-${index}`} sx={{ height: 180, objectFit: 'cover' }} />
                                        <CardContent sx={{ p: 2 }}>
                                            <Box
                                                sx={{
                                                    backgroundColor: '#ffe5e5',
                                                    color: '#d32f2f',
                                                    fontWeight: 'bold',
                                                    fontSize: '12px',
                                                    display: 'inline-block',
                                                    px: 1.5,
                                                    py: 0.5,
                                                    borderRadius: 1,
                                                    mb: 1,
                                                }}
                                            >
                                                {product.discount}
                                            </Box>
                                            <Box sx={{ alignItems: 'center', gap: 1, mb: 1 }}>
                                                <Typography sx={{ fontWeight: 'bold', fontSize: '18px', color: '#C32032' }}>{product.price}</Typography>
                                                <Typography sx={{ fontSize: '14px', color: '#888', textDecoration: 'line-through' }}>{product.oldPrice}</Typography>
                                            </Box>
                                            <Typography sx={{ fontWeight: 500, fontSize: '14px', mb: 0.5 }}>{product.title}</Typography>
                                            <Typography sx={{ fontSize: '13px', color: '#555', mb: 1 }}>{product.size}</Typography>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 0 24 24" width="18" fill="#888">
                                                    <path d="M0 0h24v24H0z" fill="none" />
                                                    <path d="M12 1a11 11 0 1011 11A11 11 0 0012 1zm0 20a9 9 0 119-9 9 9 0 01-9 9zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z" />
                                                </svg>
                                                <Typography sx={{ fontSize: '13px', color: '#555' }}>Ends in: {product.endsIn}</Typography>
                                            </Box>
                                        </CardContent>
                                    </Card>
                                ))}
                            </Box>

                            {/* Right Arrow */}
                            <IconButton
                                sx={{
                                    position: 'absolute',
                                    top: '40%',
                                    right: -10,
                                    zIndex: 1,
                                    backgroundColor: 'white',
                                    boxShadow: 2,
                                    '&:hover': { backgroundColor: '#f0f0f0' },
                                    display: 'flex',
                                }}
                                onClick={() => scroll(300)}
                            >
                                <ArrowForwardIosIcon />
                            </IconButton>
                        </Box>
                        {/* end related items you've searched */}

                        {/* Recommendations based on your order */}
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Typography
                                sx={{
                                    color: '#000',
                                    fontSize: '20px',
                                    fontWeight: 'bold',
                                    mb: 2,
                                    display: 'flex',
                                    gap: '5px',
                                    alignItems: 'center',
                                }}
                            >
                                Recommendations based on your order
                            </Typography>
                            {/*  <Typography
                            className="see-all-link"
                            sx={{
                                fontSize: '14px',
                                '&:hover': { textDecoration: 'underline' },
                            }}
                        >
                            See All
                        </Typography> */}
                        </Box>

                        {/* Carousel Wrapper */}
                        <Box sx={{ position: 'relative' }}>
                            {/* Left Arrow */}
                            <IconButton
                                sx={{
                                    position: 'absolute',
                                    top: '40%',
                                    left: -10,
                                    zIndex: 1,
                                    backgroundColor: 'white',
                                    boxShadow: 2,
                                    '&:hover': { backgroundColor: '#f0f0f0' },
                                    display: 'flex',
                                    width: 40,
                                    height: 40,
                                    borderRadius: '50%',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                                onClick={() => scroll1(-300)}
                            >
                                <ArrowBackIosIcon sx={{ ml: '8px' }} />
                            </IconButton>

                            {/* Products */}
                            <Box
                                ref={scrollRef1}
                                sx={{
                                    display: 'flex',
                                    overflowX: 'auto',
                                    gap: 2,
                                    scrollBehavior: 'smooth',
                                    pb: 1,
                                    '&::-webkit-scrollbar': { display: 'none' },
                                }}
                            >
                                {dealsProduct.map((product, index) => (
                                    <Card
                                        key={index}
                                        sx={{
                                            minWidth: 220,
                                            flex: '0 0 auto',
                                            borderRadius: 2,
                                            boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                                            transition: 'transform 0.2s ease-in-out',
                                            '&:hover': {
                                                transform: 'translateY(-5px)',
                                                boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                                            },
                                            border: '1px solid #CBCBCB',
                                        }}
                                    >
                                        <CardMedia component="img" image={product.image} alt={`product-${index}`} sx={{ height: 180, objectFit: 'cover' }} />
                                        <CardContent sx={{ p: 2 }}>
                                            <Box
                                                sx={{
                                                    backgroundColor: '#ffe5e5',
                                                    color: '#d32f2f',
                                                    fontWeight: 'bold',
                                                    fontSize: '12px',
                                                    display: 'inline-block',
                                                    px: 1.5,
                                                    py: 0.5,
                                                    borderRadius: 1,
                                                    mb: 1,
                                                }}
                                            >
                                                {product.discount}
                                            </Box>
                                            <Box sx={{ alignItems: 'center', gap: 1, mb: 1 }}>
                                                <Typography sx={{ fontWeight: 'bold', fontSize: '18px', color: '#C32032' }}>{product.price}</Typography>
                                                <Typography sx={{ fontSize: '14px', color: '#888', textDecoration: 'line-through' }}>{product.oldPrice}</Typography>
                                            </Box>
                                            <Typography sx={{ fontWeight: 500, fontSize: '14px', mb: 0.5 }}>{product.title}</Typography>
                                            <Typography sx={{ fontSize: '13px', color: '#555', mb: 1 }}>{product.size}</Typography>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 0 24 24" width="18" fill="#888">
                                                    <path d="M0 0h24v24H0z" fill="none" />
                                                    <path d="M12 1a11 11 0 1011 11A11 11 0 0012 1zm0 20a9 9 0 119-9 9 9 0 01-9 9zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z" />
                                                </svg>
                                                <Typography sx={{ fontSize: '13px', color: '#555' }}>Ends in: {product.endsIn}</Typography>
                                            </Box>
                                        </CardContent>
                                    </Card>
                                ))}
                            </Box>

                            {/* Right Arrow */}
                            <IconButton
                                sx={{
                                    position: 'absolute',
                                    top: '40%',
                                    right: -10,
                                    zIndex: 1,
                                    backgroundColor: 'white',
                                    boxShadow: 2,
                                    '&:hover': { backgroundColor: '#f0f0f0' },
                                    display: 'flex',
                                }}
                                onClick={() => scroll1(300)}
                            >
                                <ArrowForwardIosIcon />
                            </IconButton>
                        </Box>
                        {/* End Recommendations based on your order */}
                    </Box>


                    {/* ads */}
                    <Box ref={rightAdsRef} sx={{ p: 2 }} width={{ xs: "100%", md: '30%' }}>
                        <img
                            src={beauty_products}
                            alt={`product-beauty-products`}
                            style={{
                                width: '100%',
                                objectFit: 'cover',
                                // borderRadius: '8px',
                                height: '100%'
                            }}
                        />
                        <Typography className="see-all-link"
                            sx={{
                                fontSize: '14px',
                                '&:hover': {
                                    textDecoration: 'underline',
                                },
                                textAlign: 'right'
                            }}
                        >
                            Shop beauty products
                        </Typography>
                    </Box>

                </Box>
            </Box>
            {/* end body section */}

            {/* footer */}
            <Footer />
            {/* end footer */}
        </>
    );
}

export default OrderPlaced;